var exports = {
  "$x": "assigneeEventContainer__oLY9hb",
  "YG": "assigneeMarginRight__wmsRdp",
  "OE": "assigneeMarginHorizontal__Dwz0yC",
  "mp": "assigneeLink__Vm5jp6",
};

module.exports = exports;
